import generateUtilityClasses from "../../utils/generateUtilityClasses/generateUtilityClasses.es.js";
import generateUtilityClass from "../../utils/generateUtilityClass/generateUtilityClass.es.js";
function getTabUtilityClass(slot) {
  return generateUtilityClass("MuiTab", slot);
}
const tabClasses = generateUtilityClasses("MuiTab", ["root", "labelIcon", "textColorInherit", "textColorPrimary", "textColorSecondary", "selected", "disabled", "fullWidth", "wrapped", "iconWrapper"]);
const tabClasses$1 = tabClasses;
export {
  tabClasses$1 as default,
  getTabUtilityClass
};
//# sourceMappingURL=tabClasses.es.js.map
